<template>
  <div class="c-aed-ownerSearch">
    <div class="o-grid o-grid--gutter-small">
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <h4
            class="c-aed-adminChange__text-label o-heading o-heading--bold o-heading--size-4 o-label o-label--block"
          >
            {{ translationsOwnerModal.existingOwners }}
          </h4>
          <input
            type="search"
            :placeholder="translationsOwnerModal.searchExistingOwnersByEmail"
            v-model="searchTerm"
            @input="searchOwners"
            class="c-aed-ownerSearch__input o-input o-input--modal o-input--search"
          />
        </div>
        <div class="o-grid__item o-grid__item--12">
          <ul v-if="owners.length > 0" class="c-aed-ownerSearch__list">
            <li
              class="c-aed-ownerSearch__item"
              v-for="owner in owners"
              :key="owner.id"
              @click="selectOwner(owner)"
              @keyup.enter="selectOwner(owner)"
              :title="`${owner.name} ${owner.secondaryName}`"
              tabindex="0"
            >
              <div
                class="o-grid o-grid--gutter-small o-grid--align-items-center"
              >
                <div class="o-grid__group">
                  <div class="o-grid__item o-grid__item--10">
                    <div class="c-aed-ownerSearch__item-name">
                      {{ owner.name }} {{ owner.secondaryName }}
                    </div>
                    <div class="c-aed-ownerSearch__item-email">
                      {{ owner.email }}
                    </div>
                    <div
                      class="c-aed-ownerSearch__item-pending"
                      v-if="owner.isAwaiting"
                    >
                      {{ translationsOwnerModal.isAwaiting }}
                    </div>
                    <div
                      class="c-aed-ownerSearch__item-conflict"
                      v-if="currentOwnerId === owner.id"
                    >
                      {{ translationsOwnerModal.equalsCurrent }}
                    </div>
                  </div>
                  <div
                    class="o-grid__item o-grid__item--grow-0 o-grid__item--align-right"
                  >
                    <div
                      class="o-button o-button--action o-button--round"
                      :class="{
                        'o-button--light': selectedOwner !== owner
                      }"
                    >
                      <svg
                        class="o-svg-icon o-button__icon"
                        viewBox="0 0 64 64"
                        type="image/svg+xml"
                        v-if="selectedOwner === owner"
                      >
                        <use
                          xlink:href="spritemap.svg#sprite-check-thinline"
                          x="0"
                          y="0"
                        ></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "lodash";
export default {
  data() {
    return {
      section: "profile",
      searchTerm: ""
    };
  },
  props: {
    currentOwnerId: { type: Number }
  },
  computed: {
    ...mapState("owners", ["owners", "selectedOwner"]),
    ...mapState("translations", {
      translationsOwnerModal: "ownerModal"
    })
  },
  methods: {
    searchOwners: debounce(function() {
      if (this.searchTerm.length < 3) return;
      const payload = {
        api: this.$api,
        section: this.section,
        email: this.searchTerm
      };
      const { dispatch } = this.$store;
      dispatch("owners/getOwners", payload);
    }, 250),
    selectOwner(owner) {
      this.$store.commit("owners/setSelectedOwner", owner);
    }
  }
};
</script>

<style lang="scss">
.c-aed-ownerSearch {
  &__input {
    width: 100%;
  }
  &__list {
    border-top: 1px solid $s-cp-neutral-600;
    border-bottom: 1px solid $s-cp-neutral-600;
    max-height: 236px;
    overflow: auto;
  }
  &__item {
    padding: 15px 10px 20px;
    border-bottom: 1px solid $s-cp-neutral-600;
    cursor: pointer;
    overflow: hidden;
    &:last-child {
      border-color: transparent;
    }
  }

  &__item-name {
    color: $s-cp-sup-blue;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &__item-email {
    color: $s-cp-neutral-400;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__item-pending,
  &__item-conflict {
    color: $s-cp-sup-red;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
